import '@mdi/font/css/materialdesignicons.css'
import Vue from 'vue';
import Vuetify from 'vuetify/lib/framework';

import Icons from '@/components/icons/'

Vue.use(Vuetify);

let themeColors = {
  primary: '#248983',
  accent: '#248983',
}
if(process.env.VUE_APP_THEME === 'yar') {
  themeColors = {
    primary: '#01adc9',
    accent: '#01adc9',
  }
}

export default new Vuetify({
  icons: {
    values: {
      calendar: { component: Icons.calendar, },
      user: { component: Icons.user, },
      gender: {component: Icons.gender},
      mailSolid: {component: Icons.mailSolid},
      phone: {component: Icons.phone},
      pluse: {component: Icons.pluse},
      cross: {component: Icons.cross},
      food: {component: Icons.food},
      check: {component: Icons.check},
      qr: {component: Icons.qr},
      cure: {component: Icons.cure},
      morning: {component: Icons.morning},
      day: {component: Icons.day},
      evening: {component: Icons.evening},
      clock: {component: Icons.clock},
      carRight: {component: Icons.carRight},
      carLeft: {component: Icons.carLeft},
      outlineMinus: {component: Icons.outlineMinus},
      outlinePlus: {component: Icons.outlinePlus},
    },
  },

  theme: {
    themes: {
      light: themeColors,
      // тема для ключей
      // light: {
      //   primary: '#248983',
      //   accent: '#248983',
      // },
      // тема для яра
      // light: {
      //   primary: '#01adc9',
      //   accent: '#01adc9',
      // },
    },
  },
});
